import React, { useEffect, useState } from "react";
import "./Counter.scss";

const CounterInput: React.FC<{value?: number | string, onChange?: (val: number) => void, disabled?: boolean }> = ({value = 0, onChange, disabled=false }) => {
    const [count, setCount] = useState<number>(Number(value) ?? 0);

    useEffect(() => {
        setCount(Number(value) ?? 0)
    }, [value])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Allow only numeric values
        if (value === "" || /^[0-9]+$/.test(value)) {
            setCount(value === "" ? 0 : parseInt(value));
        }
    };

    useEffect(() => {
        onChange?.(count ?? 0);
    }, [count])

    const increment = () => setCount((prev) => prev + 1);
    const decrement = () => setCount((prev) => (prev > 0 ? prev - 1 : 0));

    return (
        <div className="counter-container">
            <button className="counter-btn" disabled={disabled} onClick={decrement}>
                –
            </button>
            <input
                disabled={disabled}
                type="text"
                value={count}
                onChange={handleChange}
                className="counter-input"
            />
            <button className="counter-btn" disabled={disabled} onClick={increment}>
                +
            </button>
        </div>
    );
};

export default CounterInput;
